export default __webpack_public_path__ + "images/ZT.cdcb253.png";